import {createContext} from "react";

function noop() {}

export const AuthContext = createContext({
        userName: '',
        token: null,
        userId: null,
        roleId: null,
        login: noop,
        logout: noop,
        loginWithoutRemember: noop,
        isAuthenticated: false
    }
)
